export default __webpack_public_path__ + "static/article-travel-finance-129b92a318b4acb3530ef62b96060118.jpg";